/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_InvalidInputs */

const en_directory_submit_check_invalid = /** @type {(inputs: Directory_Submit_Check_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid website URL (https://example.com).`)
};

const zh_directory_submit_check_invalid = /** @type {(inputs: Directory_Submit_Check_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的网址（https://example.com）。`)
};

/**
* | output |
* | --- |
* | "Enter a valid website URL (https://example.com)." |
*
* @param {Directory_Submit_Check_InvalidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_invalid = /** @type {((inputs?: Directory_Submit_Check_InvalidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_InvalidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_invalid(inputs)
	return zh_directory_submit_check_invalid(inputs)
});
export { directory_submit_check_invalid as "directory.submit.check.invalid" }